// extracted by mini-css-extract-plugin
module.exports = {"table":"VehicleReportPrintCanceledTable_table_33tVC","subHeader":"VehicleReportPrintCanceledTable_subHeader_js7hU"};